module.exports = __webpack_public_path__ + "img/TechTownWatch_ua.6fb4ca2b.webp";